import { queryOptions } from '@tanstack/react-query'

import { getProductsAction } from '@/actions/products/get-products-action'
import { ProductsQueryType } from '@/schemas/product/products-query'

export const productQuery = {
  getProducts: (query: ProductsQueryType) =>
    queryOptions({
      queryKey: ['products', query],
      queryFn: async () => {
        const response = await getProductsAction({ query })
        if (response.type === 'error') {
          throw new Error('Failed to fetch products', { cause: response.error })
        }
        const { results, totalCount } = response.data
        let rank = 1
        return {
          results: results.map((result) => ({
            ...result,
            rank: result.tags.find(({ code }) => code === 'New') ? 0 : rank++,
          })),
          totalCount,
        }
      },
    }),
}
